import api from '@/services/api';

export default {
  async getDropdown() {
    try {
      let response = await api.get('GroupTypes/Dropdown');
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}
